import React from "react";
import { Box, Typography } from "@mui/material";

function Header() {
  return (
    <Box mb={3}>
      <Typography variant="h3">
        Create Promotion
      </Typography>
    </Box>
  );
}

export default Header;